/**
 * @generated SignedSource<<bb24d64fcccadbb47cd429f27abc39c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContentType = "assignment" | "assignment_submission" | "attachment" | "comment" | "confirmation" | "custom" | "embed" | "module" | "occurrence" | "post" | "quiz" | "survey" | "text" | "video" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BrainSearchSidePanelToggle_ContentUsageFragment$data = {
  readonly content: {
    readonly type: ContentType;
  };
  readonly id: string;
  readonly " $fragmentType": "BrainSearchSidePanelToggle_ContentUsageFragment";
};
export type BrainSearchSidePanelToggle_ContentUsageFragment$key = {
  readonly " $data"?: BrainSearchSidePanelToggle_ContentUsageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchSidePanelToggle_ContentUsageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrainSearchSidePanelToggle_ContentUsageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "b3be3bdd343242d83b990ff92e9f1de1";

export default node;
